// File: src/App.tsx
import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import CampaignUnitsList from './pages/CampaignUnitsList'
import CampaignUnitDetail from './pages/CampaignUnitDetail'
import { DataProvider } from './DataProvider'
import { useDataFetch } from './hooks/useDataFectch'

const AppContent = () => {
  useDataFetch('leagues/soccer', 'leagues')
  useDataFetch('adsSettingsNew', 'adsSettings')

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<CampaignUnitsList />} />
          <Route path="/campaign-unit/:id" element={<CampaignUnitDetail />} />
        </Routes>
      </Layout>
    </Router>
  )
}
const App = () => {
  return (
    <DataProvider>
      <AppContent />
    </DataProvider>
  )
}

const styles = {
  body: {
    fontFamily: 'Arial, sans-serif',
    margin: '0',
    padding: '0',
    backgroundColor: '#f0f2f5',
  },
}

document.body.style.cssText = Object.entries(styles.body)
  .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}:${value}`)
  .join(';')

export default App
